meedy.factory('meedy.specializationModel', ['$rootScope', 'meedy.baseModel', 'meedy.specializationService',
    function($rootScope, baseModel, specializationService) {

        function SpecializationModel() {

            this.physicianSpecializations = function() {
                specializationService.physicianSpecializations().then(
                    function (list) {
                        $rootScope.$broadcast(Event.MEEDY.SPECIALIZATION.PHYSICIAN_SPECIALIZATIONS.SUCCESS, list);
                    },
                    function(error) {
                        $rootScope.$broadcast(Event.MEEDY.SPECIALIZATION.PHYSICIAN_SPECIALIZATIONS.ERROR, error);
                    }
                )
            };

            this.getOffersForSpecializationId = function(idSpecialization) {
                specializationService.getOffersForSpecializationId(idSpecialization).then(
                    function (list) {
                        $rootScope.$broadcast(Event.MEEDY.SPECIALIZATION.GET_OFFERS_FOR_SPECIALIZATION_ID.SUCCESS, list);
                    },
                    function(error) {
                        $rootScope.$broadcast(Event.MEEDY.SPECIALIZATION.GET_OFFERS_FOR_SPECIALIZATION_ID.ERROR, error);
                    }
                )
            };

            this.getDefaultOffersForSpecializationId = function(idSpecialization) {
                specializationService.getDefaultOffersForSpecializationId(idSpecialization).then(
                    function (list) {
                        $rootScope.$broadcast(Event.MEEDY.SPECIALIZATION.GET_DEFAULT_OFFERS_FOR_SPECIALIZATION_ID.SUCCESS, list);
                    },
                    function(error) {
                        $rootScope.$broadcast(Event.MEEDY.SPECIALIZATION.GET_DEFAULT_OFFERS_FOR_SPECIALIZATION_ID.ERROR, error);
                    }
                )
            };

            this.getSpecializations = function() {
                return specializationService.getSpecializations().then(
                    function (list) {
                        return list;
                    },
                    function(error) {
                        $rootScope.$broadcast(Event.MEEDY.SPECIALIZATION.GET_DEFAULT_OFFERS_FOR_SPECIALIZATION_ID.ERROR, error);
                    }
                )
            };

            this.specializationsFromMedicalPost = function() {
                return specializationService.specializationsFromMedicalPost().then(
                    function (list) {
                        return list;
                    },
                    function(error) {
                        $rootScope.$broadcast(Event.MEEDY.SPECIALIZATION.GET_DEFAULT_OFFERS_FOR_SPECIALIZATION_ID.ERROR, error);
                    }
                )
            };

        }

        return new SpecializationModel();
    }
]);
